<template>
  <div class="new-group__member-form">
    <div class="form-header">
      <p class="text-secondary-orange font-semibold">Group Members</p>
    </div>
    <div class="new-group__member-form-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="member-form__member-select">
              <div class="custom-form-select cursor-pointer">
                <div
                  class="custom-form-select__selected closed"
                  @click="showOptions = !showOptions"
                >
                  <small>Select Users To add them</small>
                  <span>
                    <svg
                      data-v-17902353=""
                      width="14"
                      height="7"
                      viewBox="0 0 10 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        data-v-17902353=""
                        d="M1 1.03467L5 5.03467L9 1.03467"
                        stroke="#F57A4D"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </span>
                </div>
                <transition name="select-options">
                  <div class="custom-form-select__options" v-if="showOptions">
                    <div
                      class="custom-form-select__option"
                      :class="{ active: selectedUserId == user.id }"
                      v-for="user in users"
                      :key="user.id"
                      @click="selectUser(user)"
                    >
                      <p>{{ user.firstName }} {{ user.lastName }}</p>
                      <small>({{ user.roles }})</small>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <table class="custom-table responsive-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <!-- <th>Role</th> -->
                  <th>Date Added</th>
                  <th>Member Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody v-if="selectedUsers.length == 0">
                <tr>
                  <td></td>
                  <td></td>
                  <td>No users selected!</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="user in selectedUsers" :key="user.id">
                  <td>
                    {{ user.firstName }} {{ user.lastName }} - ({{
                      user.roles
                    }})
                  </td>
                  <!-- <td>
                    <el-select v-model="user.role.name">
                      <el-option
                        v-for="role in roles"
                        :key="role.id"
                        :label="role.name"
                        :value="role.id"
                      >
                      </el-option>
                    </el-select>
                  </td> -->
                  <td>{{ user.createdAt | formatDate }}</td>
                  <td>
                    <span v-if="user.isDeactivated == 'false'">Active</span>
                    <span v-else>Inactive</span>
                  </td>
                  <td
                    class="text-secondary-orange font-semibold cursor-pointer"
                    @click="removeUser(user)"
                  >
                    Remove
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import FormSelect from "./UserSelect";
export default {
  components: {
    // FormSelect,
  },
  props: ["creatingGroup", "isButtonDisabled", "refreshGroups"],
  data() {
    return {
      selectedUsers: [],
      selectedUserId: "",
      showOptions: false,
      users: [],
      role: "",
      roles: [],
    };
  },
  mounted() {
    this.getAllUsers();
    this.getAllRoles();
  },
  watch: {
    refreshGroups() {
      if (this.refreshGroups) {
        this.selectedUsers = [];
      }
    },
  },
  methods: {
    async getAllRoles() {
      try {
        let response = await this.$_getRoles();
        console.log(response);
        this.roles = response.data.roles;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllUsers() {
      try {
        let response = await this.$_getAllUsers();
        this.users = response.data.findGroupUser;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    selectUser(user) {
      this.selectedUserId = user.id;
      let userIndex = this.selectedUsers.indexOf(user);
      if (userIndex < 0) {
        this.selectedUsers.push(user);
        let userData = {
          groupuserId: user.id,
        };
        this.$emit("select-user", userData);
      }
      this.showOptions = false;
    },
    removeUser(user) {
      this.$emit("remove-user", user.id);
      let userIndex = this.selectedUsers.indexOf(user);
      this.selectedUsers.splice(userIndex, 1);
    },
  },
};
</script>

<style scoped>
.form-header {
  margin-bottom: 1rem;
}
.custom-table th {
  padding-top: 0;
}
.custom-form-select__selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.5px solid #f8ad91;
  border-radius: 4px;
  padding: 0.65rem 0.75rem;
  width: 16rem;
}
.custom-form-select__options {
  position: absolute;
  width: 16rem;
  background-color: #ffffff;
  z-index: 999;
  border: 0.5px solid #f8ad91;
  border-radius: 4px;
  padding: 0.45rem 0.35rem;
  margin-top: 1rem;
}
.custom-form-select__option {
  padding: 0.5rem 0.35rem;
  margin-bottom: 0.5rem;
}
.custom-form-select__option.active {
  background: #f57a4d;
  border-radius: 3px;
  color: #ffffff;
}
.select-options-enter,
.select-options-leave-to {
  opacity: 0;
  transform: translateY(-20%);
}
.select-options-enter-to,
.select-options-leave {
  opacity: 1;
  transform: translateY(0);
}
.select-options-enter-active,
.select-options-leave-active {
  transition: all ease 0.4s;
}
.el-select {
  width: 10rem !important;
}
@media screen and (max-width: 768px) {
  .member-form__member-select {
    margin-bottom: 2rem;
  }
}
</style>
